export var ClientType;
(function (ClientType) {
    ClientType[ClientType["DESKTOP"] = 1] = "DESKTOP";
    ClientType[ClientType["MOBILE"] = 2] = "MOBILE";
})(ClientType || (ClientType = {}));
//# sourceMappingURL=ClientType.js.map